import Routr from 'routr';
import { Subject } from 'rxjs';
import { parseConfig } from './helpers';
import { RouterMatchResult } from './RouterMatchResult';
import { RouterApi } from './RouterApi';
var NavigationRouter = /** @class */ (function () {
    function NavigationRouter(config, history, getContext, useHashbang) {
        var _this = this;
        if (useHashbang === void 0) { useHashbang = true; }
        this.history = history;
        this.getContext = getContext;
        this.useHashbang = useHashbang;
        this.removeHistoryListener = null;
        this.subject = new Subject();
        this.resolvePath = function (name, params, query) {
            var path = _this.routr.makePath(name, params || {}, query);
            if (!path) {
                throw new Error("Router error: can't resolve path for \"" + name + "\" name");
            }
            var result = path.replace(/\/+$/, '').replace(/\/+\?/, '?') || '/';
            return "" + (_this.useHashbang ? '/#' : '') + result;
        };
        this.resolveRoute = function (url) {
            var matchResult = _this.match(url);
            return {
                name: matchResult.getName(),
                params: matchResult.getParams(),
                query: matchResult.getQuery()
            };
        };
        this.block = function (prompt) {
            if (_this.unblockCallback) {
                throw new Error('Router error: a router supports only one block at a time');
            }
            _this.unblockCallback = _this.history.block(prompt);
        };
        this.unblock = function () {
            var _a;
            (_a = _this.unblockCallback) === null || _a === void 0 ? void 0 : _a.call(_this);
            _this.unblockCallback = undefined;
        };
        this.isBlocked = function () {
            return !!_this.unblockCallback;
        };
        this.match = function (url) {
            var urlDoc = document.createElement('a');
            urlDoc.href = url;
            var pathname = urlDoc.pathname, search = urlDoc.search, hash = urlDoc.hash;
            var parsedUrl = ("/" + pathname + search + hash).replace(/\/+/g, '/');
            var routeUrl = _this.useHashbang ? parsedUrl.replace(/[\w/-]+#\//, '/') : parsedUrl;
            var result = _this.routr.getRoute(routeUrl);
            if (!result) {
                return _this.noMatchResult;
            }
            return new RouterMatchResult({
                name: result.name || '',
                path: result.path || '',
                parents: result.config.parents || [],
                redirect: result.config.redirect || '',
                resourceName: result.config.resourceName || null,
                guards: result.config.guards
            }, {
                params: result.params || {},
                query: result.query
            }, _this.getContext);
        };
        this.config = parseConfig(config.route);
        this.routr = new Routr(this.config.map(function (item) { return ({
            name: item.name,
            path: item.path,
            method: 'get',
            parents: item.parents,
            redirect: item.redirect,
            resourceName: item.resourceName,
            guards: item.guards
        }); }));
        this.currentMatch = null;
        this.noMatchResult = new RouterMatchResult({
            name: config.noMatchName || '',
            path: '',
            guards: [],
            parents: []
        }, null, this.getContext);
        if (config.noMatchRedirect && config.noMatchRedirect.name) {
            this.noMatchResult = this.match(this.resolvePath(config.noMatchRedirect.name));
        }
    }
    NavigationRouter.prototype.run = function (url) {
        var _this = this;
        this.updateCurrentMatch(this.match(url));
        if (this.removeHistoryListener) {
            throw new Error('Router error: before run router again you must all "terminate" method');
        }
        this.removeHistoryListener = this.history.listen(function (_a) {
            var pathname = _a.pathname, search = _a.search, hash = _a.hash;
            var newUrl = "" + pathname + search + hash;
            _this.updateCurrentMatch(_this.match(newUrl));
        });
    };
    NavigationRouter.prototype.terminate = function () {
        if (this.removeHistoryListener) {
            this.removeHistoryListener();
            this.removeHistoryListener = null;
        }
    };
    NavigationRouter.prototype.isActive = function () {
        return !!this.removeHistoryListener;
    };
    NavigationRouter.prototype.asObservable = function () {
        return this.subject.asObservable();
    };
    NavigationRouter.prototype.getCurrentMatch = function () {
        if (!this.currentMatch) {
            throw new Error('Router error: before call getCurrentMatch you must call run');
        }
        return this.currentMatch;
    };
    NavigationRouter.prototype.isRouteAllow = function (routeName, params, query) {
        return this.match(this.resolvePath(routeName, params, query)).isAllow();
    };
    NavigationRouter.prototype.getActions = function () {
        return new RouterApi(this, this.history);
    };
    NavigationRouter.prototype.updateCurrentMatch = function (matchResult) {
        if (matchResult.isDisallow()) {
            var _a = matchResult.getGuardResult(), redirect = _a.redirect, stubName = _a.stubName;
            if (redirect && redirect.name) {
                var redirectUrl = this.resolvePath(redirect.name);
                this.redirect(this.match(redirectUrl));
                return;
            }
            if (!stubName) {
                this.updateCurrentMatch(this.noMatchResult);
                return;
            }
        }
        if (matchResult.hasRedirect()) {
            this.redirect(matchResult);
            return;
        }
        this.currentMatch = matchResult;
        this.subject.next(matchResult);
    };
    NavigationRouter.prototype.redirect = function (matchResult) {
        var redirectUrl = this.resolvePath(matchResult.getRedirect().name, matchResult.getParams(), matchResult.getQuery());
        var newMatchResult = this.match(redirectUrl);
        this.history.replace(redirectUrl);
        this.updateCurrentMatch(newMatchResult);
    };
    return NavigationRouter;
}());
export { NavigationRouter };
//# sourceMappingURL=NavigationRouter.js.map